import React from 'react';
import styles from './ExternalLink.module.css';
export function ExternalLink(props) {
    return (React.createElement("a", { target: '_blank', rel: 'noreferrer', href: props.link, className: styles.link }, props.display));
}
